import React, { FC } from 'react';
import { Node } from 'src/common/interfaces/node.interface';
import { DashboardInsightsJourneysJourneyPdfViewsChart } from '../journey/pdf-views-chart';
import { DocumentInsight } from '../constants';

type Props = {
  node: Node;
  documentInsights: DocumentInsight[];
};

export const DashboardInsightsJourneysJourneyVisitorDocumentInsights: FC<Props> = ({ node, documentInsights }) => {
  return (
    <div className='flex flex-col gap-4'>
      <div className='text-bedrock-black text-bedrock-p-strong'>Document Insights</div>
      <DashboardInsightsJourneysJourneyPdfViewsChart
        node={node}
        documentInsights={documentInsights}
        chartOptions={{ yLabel: 'Total time in seconds' }}
      />
    </div>
  );
};
